import { truncateAddress, truncateEns } from '../utils/truncate.js';
import { useQuery } from '@tanstack/react-query';
export default (address, queryOptions) => {
    const addressLowercase = address?.toLowerCase();
    const url = `https://api.ensideas.com/ens/resolve/${addressLowercase}`;
    const response = useQuery({
        queryKey: ['useENSResolver', address],
        queryFn: () => fetch(url).then((response) => response.json()),
        ...queryOptions,
        enabled: address && address.length > 0
            ? queryOptions?.enabled !== undefined
                ? queryOptions.enabled
                : true
            : false
    });
    const shortAddress = address ? truncateAddress(address) : '';
    const shortName = response.data?.name ? truncateEns(response.data.name) : null;
    let displayName = '';
    if (response.data?.name) {
        displayName = shortName || '';
    }
    else if (address) {
        displayName = shortAddress || '';
    }
    return {
        ...response,
        address,
        name: response.data?.name,
        shortName,
        displayName,
        shortAddress,
        avatar: response.data?.avatar
    };
};
//# sourceMappingURL=useENSResolver.js.map